
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import QuickSmsTransfer from '@/components/QuickSmsTransfer';
import AdvancedTransferButton from '@/components/payment/AdvancedTransferButton';

interface StandardPaymentViewProps {
  advancedTransferText: string;
  onAdvancedTransferClick: () => void;
}

const StandardPaymentView: React.FC<StandardPaymentViewProps> = ({
  advancedTransferText,
  onAdvancedTransferClick
}) => {
  return (
    <Card>
      <CardContent className="p-6">
        <QuickSmsTransfer />
        
        <div className="mt-6 text-center">
          <AdvancedTransferButton 
            text={advancedTransferText} 
            onClick={onAdvancedTransferClick} 
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default StandardPaymentView;
